<template>
    <div>
        <div class="">
            <nav class="flex space-x-4" aria-label="Tabs">
                <InertiaLink v-for="item in items" :key="item.name" :href="item.href" :class="[current == item.key ? 'bg-secondary text-white' : 'text-gray-500 hover:text-gray-700', 'px-3 py-2 font-medium text-sm rounded-md']" :aria-current="item.current ? 'page' : undefined">
                    {{ item.name }}
                </InertiaLink>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: Array,
        current: String,
    },
    data() {
        return {
            currentUrl: '',
        };
    },
}
</script>
